export const OVERVIEW_QUERY_KEYS = {
  USER_PROFILE: 'user-profile',
  WEATHER: 'weather',
  SINGLE_TEAM: 'team',
};

export const PROFILE_AUTH_ENDPOINT = {
  GET_AUTH_PROFILE: 'auth/profile',
} as const;

export const WEATHER_ENDPOINT = {
  CURRENT_WEATHER: '/weather/current',
} as const;

export const TEAM_ENDPOINT = {
  SINGLE_TEAM: '/teams',
} as const;
